import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import navbarPic from "../../../../src/assets/images/navbar.jpg";
import mobileX from "../../../../src/assets/icons/mobileX.svg";
import logo from "../../../../src/assets/icons/neologo.png";
import Marquee from "react-fast-marquee";
import ParticlesComponent from "./ParticlesComponent";
import gsap from "gsap";
function MobileNavbar({
    setPageName,
    data,
    pageName,
    scrollToComponent,
    setScrollToComponent,
    handleScrollToComponent,
    setIsMenuOpen,
    isMenuOpen,
    setIsLargeScreen,
    isLargeScreen,
}) {
    // const [targetElementId, setTargetElementId] = useState(null);

    // const handleNavToHome = (id) => {
    //     gsap.to("#mobileNavbar", {
    //         y: "-100%",
    //         opacity: 0,
    //         yoyo: true,
    //         duration: 1.5,
    //         ease: "power1.out",
    //         onComplete: () => {
    //             setPageName("normal");
    //             setScrollToComponent(id);
    //         },
    //     });
    // };
    const navigate = useNavigate();

    // useEffect(() => {
    //     // If targetElementId is set, update the URL with the target element ID
    //     if (targetElementId) {
    //         window.history.replaceState(
    //             null,
    //             null,
    //             `?targetElement=${targetElementId}`
    //         );
    //     }
    // }, [targetElementId]);

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        console.log("clicked", id);
        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: 100, // adjust this value as needed
                },
                ease: "power2.inOut",
            });
        }
    };

    const handleNavigation = (item) => {
        if (item.linkTo === "team") {
            navigate("/team");
            window.scrollTo(0, 0);
        } else if (item.linkTo === "press") {
            navigate("/press");
            window.scrollTo(0, 0);
        } else if (
            ["projects", "careers", "partners", "secondpage"].includes(
                item.linkTo
            ) &&
            window.location.pathname !== "/"
        ) {
            navigate("/", { state: { scrollToElement: item.linkTo } });
        } else {
            scrollToElement(item.linkTo);
        }
        closeMenu();
    };

    const handleNormalPageNavigation = (route) => {
        navigate(`/${route}`);
        window.scrollTo(0, 0);
        closeMenu();
    };

    useEffect(() => {
        if (isMenuOpen === true) {
            gsap.from("#mobileNavbar", {
                y: "-100%",
                opacity: 0,
                yoyo: true,
                duration: 1.5,
                ease: "power3.out",
            });
        }
    }, [isMenuOpen]);

    const closeMenu = () => {
        // Animate the navbar closing
        gsap.to("#mobileNavbar", {
            y: "-100%", // Assuming the navbar slides out upwards
            opacity: 0,
            duration: 1.5,
            ease: "power3.out",
            onComplete: () => {
                // After animation completes, set the state
                setIsMenuOpen(false);
                // window.scrollTo(0, 0);
            },
        });
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        // Cleanup function to set overflow to 'auto' when component unmounts
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isMenuOpen]);

    return (
        <div
            className=" flex-col flex   h-screen  overflow-auto relative  z-50 bg-black "
            id="mobileNavbar"
        >
            <div className="w-[90%] py-10 pt-14 mx-auto relative h-full">
                <div class="absolute inset-y-0 left-0 w-px bg-white/10 z-0"></div>
                <div class="absolute inset-y-0 left-1/2 w-px bg-white/10 z-0"></div>
                <div class="absolute inset-y-0 right-0 w-px bg-white/10 z-0"></div>
                <div className="flex md:flex-row justify-between gap-10  z-20   ">
                    <div className="z-20">
                        <img
                            src={logo}
                            className="w-[170px]"
                            alt=""
                            onClick={() => handleNormalPageNavigation("")}
                        />
                    </div>
                    <div className=" flex items-center justify-center flex-row align-middle gap-2 z-20 text-white cursor-pointer">
                        <img
                            src={mobileX}
                            className="w-6 cursor-pointer"
                            onClick={closeMenu}
                            alt=""
                        />
                    </div>
                </div>
                <div className="flex  mt-10 flex-col justify-between items-center align-middle z-20 ">
                    <div className="w-full ">
                        {data.navLinks.map((item) => (
                            <div
                                onClick={() => handleNavigation(item)}
                                className=" w-full border-white border-y py-5 p-4 flex justify-between cursor-pointer"
                            >
                                <p>{item.name}</p>
                                <i class="fa-solid fa-chevron-right"></i>
                            </div>
                        ))}
                    </div>
                    <div className=" mt-10 w-full flex flex-col">
                        <h6 className="text-[14px] leading-[21px] text-white text-left h16">
                            Powered by:
                        </h6>
                        <h6 className="mt-1 text-[12px] leading-[21px] mb-1 text-white h16">
                            Decentralised real-time Edge rendering
                        </h6>
                        <h6 className="mt-3 h16 text-left text-[12px] leading-[32px]">
                            Copyright @{new Date().getFullYear()} Neowave Studio
                        </h6>
                        <div className="flex mt-4 gap-4 pb-14  ">
                            <h6 className="h16 text-left text-[12px] leading-[32px]">
                                Privacy Policy
                            </h6>
                            <h6 className="h16 text-left text-[12px] leading-[32px]">
                                Cookies
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileNavbar;
